(function () {
  'use strict';

  var DISCOUNT_CODE = 'HANDFINISHED';
  var SEEN_COOKIE = 'sic_popup_seen';
  var OLD_ARMED_COOKIE = 'sic_armed';
  var COOKIE_DAYS = 90;
  var triggered = false;

  function setCookie(name, value, maxAge) {
    document.cookie = name + '=' + value + '; max-age=' + maxAge + '; path=/; SameSite=Lax';
  }

  function clearOldPriceState() {
    document.cookie = OLD_ARMED_COOKIE + '=; max-age=0; path=/; SameSite=Lax';

    if (document.body) {
      document.body.classList.remove('sic-armed');
    }

    document.querySelectorAll('.sic-price-armed').forEach(function (price) {
      price.hidden = true;
      price.classList.remove('is-revealed');
      price.removeAttribute('data-sic-observed');
    });

    document.querySelectorAll('.sic-price-normal').forEach(function (price) {
      price.style.removeProperty('display');
    });

    try {
      window.dispatchEvent(new CustomEvent('sic:armed-changed', { detail: { armed: false } }));
    } catch (error) {}

    try {
      if (typeof window.updateATCLabel === 'function') window.updateATCLabel();
      if (typeof window.updateMobileATC === 'function') window.updateMobileATC();
    } catch (error) {}
  }

  function shouldFire() {
    var path = window.location.pathname.replace(/^\/(en-us|en-au|en-de|en-intl|en-uk|en-gb|en-ca)(\/|$)/, '/');
    var eligiblePage = path.indexOf('/collections/') === 0 || path.indexOf('/products/') === 0;
    if (!eligiblePage) return false;

    var alreadySeen = document.cookie.split(';').some(function (cookie) {
      return cookie.trim().indexOf(SEEN_COOKIE + '=') === 0;
    });
    if (alreadySeen) return false;

    var query = new URLSearchParams(window.location.search);
    if (query.has('_kx') || query.get('utm_source') === 'klaviyo') return false;

    return true;
  }

  function showPopup() {
    if (triggered || !shouldFire()) return;
    triggered = true;

    var root = document.getElementById('sic-popup-root');
    if (!root) return;

    root.style.display = 'flex';

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'popup_shown', { popup_name: 'first_buyer_20' });
      }
    } catch (error) {}
  }

  function hidePopup(reason) {
    var root = document.getElementById('sic-popup-root');
    if (!root) return;

    var card = root.querySelector('.sic-card');
    if (card) card.classList.add('is-dismissed');

    setCookie(SEEN_COOKIE, '1', 60 * 60 * 24 * COOKIE_DAYS);

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'letter_' + reason, { popup_name: 'first_buyer_20' });
      }
    } catch (error) {}

    window.setTimeout(function () {
      root.style.display = 'none';
      if (card) card.classList.remove('is-dismissed');
    }, 420);
  }

  function applyCoupon() {
    var redirect = window.location.pathname + window.location.search;
    hidePopup('accepted');

    window.setTimeout(function () {
      window.location.href = '/discount/' + DISCOUNT_CODE + '?redirect=' + encodeURIComponent(redirect);
    }, 220);
  }

  function wirePopup() {
    var root = document.getElementById('sic-popup-root');
    if (!root) return;

    var closeButton = root.querySelector('.sic-close');
    var offerButton = root.querySelector('.sic-button');

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        hidePopup('dismissed');
      });
    }

    if (offerButton) {
      offerButton.addEventListener('click', applyCoupon);
    }

    root.addEventListener('click', function (event) {
      if (event.target === root) hidePopup('dismissed');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.style.display === 'flex') {
        hidePopup('dismissed');
      }
    });
  }

  function onScroll() {
    var documentHeight = document.documentElement.scrollHeight;
    var progress = (window.scrollY + window.innerHeight) / documentHeight;

    if (progress >= 0.30) {
      showPopup();
      window.removeEventListener('scroll', onScroll);
    }
  }

  function init() {
    clearOldPriceState();
    wirePopup();

    if (!shouldFire()) return;

    window.setTimeout(showPopup, 8000);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

